/* global window */

import $ from 'jquery';
import URLQueryBuilder from 'url-query-builder';

import './TestPromo.scss';
import template from './TestPromo.vhtml';

window.dataLayer = window.dataLayer || [];

export default {
	name: 'TestPromo',
	template: template,
	props: {
		housing: {
			type: String,
			default: null,
		},
		situation: {
			type: String,
			default: null,
		},
		interests: {
			type: Array,
			default: () => [],
		},
		situationAnswers: {
			type: Array,
			default: () => [],
		},
		housingAnswers: {
			type: Array,
			default: () => [],
		},
		interestsAnswers: {
			type: Array,
			default: () => [],
		},
		isOpen: {
			type: Boolean,
			default: false,
		},
		landingPage: {
			type: String,
			required: true,
		},
		theme: {
			type: String,
			default: 'default',
		},
		revertUrlOnClose: {
			type: Boolean,
			default: false,
		},
		redirectOnInvalid: {
			type: Boolean,
			default: false,
		},
	},
	data: () => ({
		showTest: false,
		situationValue: null,
		housingValue: null,
		interestsValue: null,
		originalUrl: window.location.href,
	}),
	computed: {
		situationOptions() {
			return this.situationAnswers.map((answer, i) => ({ id: i, text: answer.answer }));
		},
		housingOptions() {
			return this.housingAnswers.map((answer, i) => ({ id: i, text: answer.answer }));
		},
		interestsOptions() {
			return this.interestsAnswers.map((answer, i) => ({ id: i, text: answer.answer }));
		},
		situationSelection() {
			return  !isNaN(parseInt(this.situationValue)) ? this.situationAnswers[parseInt(this.situationValue)] : null;
		},
		housingSelection() {
			return !isNaN(parseInt(this.housingValue)) ? this.housingAnswers[parseInt(this.housingValue)] : null;
		},
		interestsSelection() {
			return this.interestsValue.map(interest => !isNaN(parseInt(interest)) ? this.interestsAnswers[parseInt(interest)] : null);
		},
		selectTheme() {
			return this.theme === 'default' ? 'test' : 'test-outline';
		},
		buttonClass() {
			return 'o-btn o-btn--big' + (this.theme === 'default' ? ' o-btn btn--outline btn--white' : ' o-btn--orange');
		},
		landingPageUrl() {
			const q = new URLQueryBuilder(this.landingPage, {
				situation: this.situationValue,
				housing: this.housingValue,
				interests: this.interestsValue,
			});

			return q.get();
		},
	},
	watch: {
		showTest() {
			if (this.showTest) {
				window.dataLayer.push({
					'event': 'openTest'
				});
			}
		},
	},
	methods: {
		open() {
			if (this.situationSelection && this.housingSelection && this.interestsSelection.length) {
				this.showTest = true;

				// Set the history state
				setHistory({ isTestOpen: this.showTest }, this.landingPageUrl);
			} else if (this.redirectOnInvalid) {
				window.location.href = this.landingPageUrl;
			}
		},
		close() {
			this.showTest = false;

			if (this.revertUrlOnClose) {
				setHistory(null, this.originalUrl, true);
			}
		},
	},
	created() {
		// Set isOpen value from properties
		this.showTest = this.isOpen;
		this.housingValue = this.housing;
		this.situationValue = this.situation;
		this.interestsValue = this.interests;

		// Listen to popstate (ie forward/back in browser)
		window.addEventListener('popstate', e => {
			if (e.state.hasOwnProperty('isTestOpen')) {
				this.showTest = e.state.isTestOpen;
			}
		});

		// Set initial state in history api
		setHistory({ isTestOpen: this.showTest }, null, true);
	},
};

/**
 * Set the history state
 *
 * @param {*} state
 * @param {string} url
 * @param {boolean} [replace=false]
 */
function setHistory(state, url, replace = false) {
	if (!(window.history.pushState || window.history.replaceState)) return;

	if (replace) {
		window.history.replaceState(state, '', url);
	} else {
		window.history.pushState(state, '', url);
	}
}


/**
 * Gets results from WP REST API
 */
function GetTestResult(situation, housing, interests) {
	const params = {
		situation,
		housing,
		interests,
		'_': '1.5',
	};

	return $.get(`/wp-json/be/v1/testresults`, params);
}
